import { Routes } from '@angular/router';

export const propertyReportRoutes: Routes = [
  {
    path: 'property-report',
    redirectTo: 'property-reports',
  },
  {
    path: 'property-reports',
    loadChildren: () => import('@rma/public/reports/address-report-view'),
    data: {
      hideFooter: true,
    },
  },
  {
    path: 'reports',
    loadChildren: () => import('@rma/public/reports/digital-property-report'),
    data: {
      hideFooter: true,
    },
  },
];
